import React from 'react';

const MoveAction = ({ width, height }: { width: number; height: number }) => {
    return (
        <div
            className="l-cropStage-moveAction"
            data-operate-type="crop-move"
            style={{
                width: width,
                height: height,
                pointerEvents: 'auto',
            }}
        />
    );
};

export default MoveAction;
